import React, { ReactNode, useReducer } from 'react';
import { DocumentCompareContext } from './context';
import { initialData, reducer } from './reducer';

type Props = {
    children: ReactNode;
};

export const DocumentCompareProvider = ({ children }: Props) => {
    const [state, dispatch] = useReducer(reducer, initialData);

    return (
        <DocumentCompareContext.Provider value={{ state, dispatch }}>
            {children}
        </DocumentCompareContext.Provider>
    );
};
